import React from "react";
import Title from "antd/es/typography/Title";

interface ExampleTitleProps {
    title?: string; // Optional title prop
}

const ExampleTitle: React.FC<ExampleTitleProps> = ({ title = "Examples" }) => {  // Default to "Examples"
    return (
        <div style={{ textAlign: "center", marginBottom: 20 }}>
            <Title level={4}>
                {title}
            </Title>
        </div>
    );
};

export default ExampleTitle;
